const startYear = new Date().getFullYear() - 2;

const selectYearOptions = Array.from({ length: 4 }, (_, i) => {
  const year = startYear + i;
  return { id: String(year), name: String(year) };
});

export default selectYearOptions;
